import Vue from 'vue';

//  Plugins
import vuetify from '@/plugins/vuetify';

import '@/plugins/vue2-touch-events';
import './plugins/analytics';
import '@/plugins/vue-clipboard2';
import './filters';
import { sync } from 'vuex-router-sync';

import App from './App.vue';
import router from './router';
import store from './store/';

// import firebase
import fb from './firebaseConfig';

//  import fonts
import 'material-design-icons-iconfont/dist/material-design-icons.css';

//import quill theme  
// import 'quill/dist/quill.snow.css';

//  import and register universal components
import CIcon from '@/components/CIcon';
Vue.component('c-icon', CIcon);
import ShortcutIcon from '@/components/ShortcutIcon';
Vue.component('shortcut-icon', ShortcutIcon);

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.configureWebpack = { devtool: 'source-map' };

//  Setup sync from router to store
sync(store, router);

let app;

fb.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      vuetify,
      render: h => h(App),
      mounted() {
        // Prevent blank screen in Electron builds
        // this.$router.push('/');
      }
    });
  }
});
